import React from 'react';

export const CustomerRegisterStep3 = ({
  loginId,
  setLoginId,
  loginPw,
  setLoginPw,
  loginPwConfirm,
  setLoginPwConfirm,
  name,
  setName,
  email,
  setEmail,
  phone,
  setPhone,
  interests,
  toggleInterest,
  isRegistrationValid,
  handleRegister
}) => {
  return (
    <div className="register-area">
      <div className="register-area__id-block">
        <div className="register-area__id-text">아이디</div>
        <input 
          className="register-area__id-input" 
          placeholder="6~20자 영문, 숫자" 
          value={loginId} 
          onChange={(e) => setLoginId(e.target.value)} 
        />
      </div>
      <div className="register-area__pw-block">
        <div className="register-area__pw-text">비밀번호</div>
        <input 
          className="register-area__pw-input" 
          type="password" 
          placeholder="8~12자 영문, 숫자, 특수문자" 
          value={loginPw} 
          onChange={(e) => setLoginPw(e.target.value)} 
        />
      </div>
      <div className="register-area__pw-confirm-block">
        <div className="register-area__pw-confirm-text">비밀번호 확인</div>
        <input 
          className="register-area__pw-comfirm-input" 
          type="password" 
          placeholder="8~12자 영문, 숫자, 특수문자" 
          value={loginPwConfirm} 
          onChange={(e) => setLoginPwConfirm(e.target.value)} 
        />
      </div>
      <div className="register-area__name-block">
        <div className="register-area__name-text">이름</div>
        <input 
          className="register-area__name-input" 
          placeholder="" 
          value={name} 
          onChange={(e) => setName(e.target.value)} 
        />
      </div>
      <div className="register-area__email-block">
        <div className="register-area__email-text">이메일</div>
        <input 
          className="register-area__email-input" 
          placeholder="" 
          value={email} 
          onChange={(e) => setEmail(e.target.value)} 
        />
      </div>
      <div className="register-area__phone-block">
        <div className="register-area__phone-text">휴대폰</div>
        <input 
          className="register-area__phone-input" 
          placeholder="" 
          value={phone} 
          onChange={(e) => setPhone(e.target.value)} 
        />
      </div>

      <div className="register-area__interest-area-text">관심분야</div>
      <div className="register-area__interest-area-block">
        {Object.keys(interests).map((key) => (
          <div 
            key={key}
            className={`register-area__interest-area-btn-block${interests[key] ? "--selected" : ""}`} 
            onClick={() => toggleInterest(key)}
          >
            <div className={`register-area__interest-area-btn-text${interests[key] ? "--selected" : ""}`}>
              {key}
            </div>
          </div>
        ))}
      </div>

      <div 
        className={`register-area__register-btn-block${ isRegistrationValid() ? '--active' : '--inactive' }`} 
        onClick={() => {
          if (isRegistrationValid()) {
            handleRegister();
          } else {
            alert('모든 필수 정보를 입력해주세요.');
          }
        }}
      >
        <div className="register-area__register-btn-text">가입완료</div>
      </div>
    </div>
  );
};